import { CONFIG_LOCAL_STORAGE } from '../constants/Define';
import { LocalStorage } from '../utils';
import * as Types from '../constants/Types';


const initialState = {
    logged: !!(LocalStorage.get(CONFIG_LOCAL_STORAGE.ACCESS_TOKEN)),
    user: {},
    authenticating: LocalStorage.get(CONFIG_LOCAL_STORAGE.AUTHENTICATING),
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.LOGIN_ACTION:
            return { ...state, logged: false, logging: true, action: "LOGIN" };
        case Types.LOGOUT_ACTION:
            return { ...state, logged: true };
        case Types.CHECK_USER_ACTION:
            return { ...state, logged: true, logging: true };
        case Types.CHECK_USER_SUCCESS:
            return { ...state, logged: true, user: action.user, logging: false };
        case Types.LOGIN_SUCCESS:
            return { ...state, logged: true, logging: false, action: "SUCCESS" };
        case Types.LOGIN_FAILED:
            return { ...state, logged: false, logging: false, action: "FAIL" };
        case Types.LOGOUT_SUCCESS:
            return { ...state, logged: false };
        case Types.LOGIN_AUTHENTICATING:
            return { ...state, authenticating: false, logging: typeof action.logging === 'boolean' ? action.logging : state.logging };
        default:
            return state;
    }
}